import React from 'react'
import { Modal } from 'react-bootstrap'
import ButtonCancell from './ButtonCancell'
import ButtonAdminpanel from './ButtonAdminpanel'


function LargePopupCertificate(props) {

    const timeStamp = Date.now();

    return (

        <div>

            <Modal
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className={props.pageSource && (props.pageSource == 'landingPage' || props.pageSource == 'companyPlanInfo') ? 'custom-modal-large' : 'modal-large'}
                show={props.LargeModalShow}
                onHide={() => props.setLargeModalShow(false)}
            >
                {/* <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='modal-title'>
                        {props.title}
                    </Modal.Title>
                </Modal.Header> */}
                <Modal.Body className={props.pageSource && (props.pageSource == 'landingPage' || props.pageSource == 'companyPlanInfo') ? 'set-width-height custom-pdf-page' : 'set-width-height'}>
                    {props.children}

                    {props.pageSource && (props.pageSource == 'landingPage' || props.pageSource == 'companyPlanInfo') ? <img src={`${props.pdfUrl}?v=${timeStamp}`} alt="orex certificate" /> : <iframe src={`${props.pdfUrl}#pagemode=none&toolbar=1&navpanes=0`}></iframe>}

                </Modal.Body>

                {(props.closeButtonLabel || props.okButtonLabel) && (
                    <Modal.Footer>

                        {props.closeButtonLabel &&
                            <ButtonCancell

                                onClick={() => props.setLargeModalShow(false)}
                            >{props.closeButtonLabel}</ButtonCancell>
                        }
                        {props.okButtonLabel &&
                            <ButtonAdminpanel
                                type={props.type}
                                onClick={props.onSubmit}
                                disabled={props.disabled}
                                className={`mx-3 ${(props.disabled) ? "Popup-disable" : ""}`}

                            >{props.okButtonLabel}</ButtonAdminpanel>
                        }
                    </Modal.Footer>
                )}
            </Modal>

        </div>
    )
}

export default LargePopupCertificate